import React, { Component, Fragment } from "react"
import Async from "react-select"
import modalIcon from "../../../assets/images/testIcon.svg"
import Field from "../../Common/Field/Field"
import ModuleHeader from "../ModuleHeader"
import Button from "../../Buttons/Button"
import ButtonIcon from "../ButtonIcon"

export default class EmbellishmentModule extends Component {
  state = {
    _id: "",
    embellishment: [],
    assignedToList: [],
    STATUS: [],
    TYPE: [],
    disabled: false
  }

  componentWillMount() {
    const {
      _id,
      embellishment,
      STATUS,
      assignedToList,
      disabled,
      TYPE,
      embellishmentProcess
    } = this.props
    this.setState({
      _id,
      embellishment,
      embellishmentProcess,
      STATUS,
      assignedToList,
      disabled,
      TYPE
    })
  }

  componentWillReceiveProps(nextProps) {
    const {
      _id,
      embellishment,
      STATUS,
      assignedToList,
      disabled,
      TYPE,
      embellishmentProcess
    } = nextProps
    this.setState({
      _id,
      embellishment,
      embellishmentProcess,
      STATUS,
      assignedToList,
      disabled,
      TYPE
    })
  }

  render() {
    const { permissions, embellishmentComments } = this.props
    const { STATUS } = this.state
    return (
      <div
        class="card-filter meeting-min-con"
        id="embellishment"
        style={{ marginBottom: ".5%" }}
      >
        <div class="col-md-12">
          <ModuleHeader
            header={"Embellishment"}
            onClick={this.onOpenModal}
            _id={this.state._id}
            process={this.state.embellishmentProcess}
            disabled={this.state.disabled}
            moduleName={"embellishment"}
            updateModulesMain={this.props.updateModulesMain}
            statusList={STATUS}
          />
          <div className="col-md-8">
            <table class="table">
              <thead class="border-bottom-0">
                <tr class="border-bottom-0">
                  <th class="border-bottom-0 text-left" width="30%">
                    Type
                  </th>
                  <th class="border-bottom-0 text-left" width="10%">
                    HH:MM
                  </th>
                  <th class="border-bottom-0 text-left" width="10%">
                    Price/30mins
                  </th>
                  <th class="border-bottom-0 text-left" width="10%">
                    {!this.state.disabled &&
                      (permissions.create || permissions.edit) && (
                        <ButtonIcon
                          buttonType="add"
                          addRemoveFunc={() => this.props.addEmb()}
                        />
                      )}
                  </th>
                </tr>
              </thead>
              <tbody>
                {this.state.embellishment.map((embellishment, index) => {
                  return (
                    <tr>
                      <td class="border-top-0">
                        <Field
                          isFormGroup={false}
                          inputType="select"
                          inputName="embType"
                          value={embellishment.embType}
                          options={this.state.TYPE}
                          onChange={this.props.updateEmbellishment}
                          index={index}
                          label={"Type "}
                          disabled={this.state.disabled}
                        />
                      </td>
                      <td class="border-top-0">
                        <Field
                          isFormGroup={false}
                          inputType="time"
                          inputName="hoursMinutes"
                          value={embellishment.hoursMinutes}
                          onChange={this.props.updateEmbellishment}
                          index={index}
                          label={"HH:MM"}
                          disabled={this.state.disabled}
                        />
                      </td>
                      <td class="border-top-0">
                        <Field
                          isFormGroup={false}
                          inputType="text"
                          inputName="pricePerHalfHour"
                          label={"Price/30mins"}
                          value={embellishment.pricePerHalfHour}
                          onChange={this.props.updateEmbellishment}
                          index={index}
                          disabled={this.state.disabled}
                        />
                      </td>

                      <td class="border-top-0">
                        {!this.state.disabled &&
                          (permissions.create || permissions.edit) && (
                            <ButtonIcon
                              buttonType="clear"
                              addRemoveFunc={() => this.props.removeEmb(index)}
                            />
                          )}
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>

          <div class="col-md-12 no-padding pl-0">
            <div class="col-md-10 step-one pl-0">
              <Field
                isFormGroup={true}
                inputType="textarea"
                inputName="embellishmentComments"
                value={embellishmentComments}
                label="comments"
                onChange={this.props.updateSampleRequest}
                disabled={this.state.disabled}
              />
            </div>
          </div>
          {permissions.create && permissions.edit && !this.state.disabled && (
            <div class="col-md-12 no-padding text-center profile-btn">
              <Button
                buttonName={"save"}
                onClick={e => this.props.createEmbellishment(e)}
              />
              <Button
                buttonName={"Complete"}
                onClick={e => this.props.completeEmbellishment(e)}
              />
            </div>
          )}
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/SampleRequest/EmbellishmentModule/index.js